import { useEffect, useState } from "react";
import { useAppDispatch } from "../app/app.store";
import { setAuthInfo } from "../app/features/auth/auth.slice";

export default function useAuthenticate() {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    if (accessToken && refreshToken) {
      dispatch(setAuthInfo({ accessToken, refreshToken }));
    }

    setIsLoading(false);
  }, [dispatch]);

  return { isLoading };
}
